import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import Send from '@/pages/Send';
import Recipients from '@/pages/Recipients';
import Transactions from '@/pages/Transactions';
import Profile from '@/pages/Profile';
import PaymentSuccess from '@/pages/PaymentSuccess';
import Admin from '@/pages/Admin';
import Wallet from '@/pages/Wallet';
import CryptoPayment from '@/pages/CryptoPayment';
import Pos from '@/pages/Pos';
import About from '@/pages/About';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import Cookies from '@/pages/Cookies';
import KYCApplication from '@/pages/KYCApplication';
import KycVerify from '@/pages/KycVerify';
import RelmInvoice from '@/pages/RelmInvoice';
import ResetPassword from '@/pages/ResetPassword';
import '@/App.css';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/send" element={<PrivateRoute><Send /></PrivateRoute>} />
          <Route path="/recipients" element={<PrivateRoute><Recipients /></PrivateRoute>} />
          <Route path="/transactions" element={<PrivateRoute><Transactions /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/wallet" element={<PrivateRoute><Wallet /></PrivateRoute>} />
          <Route path="/crypto" element={<PrivateRoute><CryptoPayment /></PrivateRoute>} />
          <Route path="/pos" element={<PrivateRoute><Pos /></PrivateRoute>} />
          <Route path="/payment-success" element={<PrivateRoute><PaymentSuccess /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
          <Route path="/kyc" element={<PrivateRoute><KYCApplication /></PrivateRoute>} />
          <Route path="/kyc/verify/:token" element={<KycVerify />} />
          <Route path="/pay/relm/:invoiceId" element={<RelmInvoice />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;